"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The AnalyticsSummaryRequest model module.
 * @module model/AnalyticsSummaryRequest
 * @version 1.1.3-alpha.1
 */
class AnalyticsSummaryRequest {
  /**
   * Constructs a new <code>AnalyticsSummaryRequest</code>.
   * @alias module:model/AnalyticsSummaryRequest
   * @param from {String} 
   * @param to {String} 
   */
  constructor(from, to) {
    AnalyticsSummaryRequest.initialize(this, from, to);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, from, to) {
    obj['from'] = from;
    obj['to'] = to;
  }

  /**
   * Constructs a <code>AnalyticsSummaryRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AnalyticsSummaryRequest} obj Optional instance to populate.
   * @return {module:model/AnalyticsSummaryRequest} The populated <code>AnalyticsSummaryRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AnalyticsSummaryRequest();
      if (data.hasOwnProperty('from')) {
        obj['from'] = _ApiClient.default.convertToType(data['from'], 'String');
      }
      if (data.hasOwnProperty('to')) {
        obj['to'] = _ApiClient.default.convertToType(data['to'], 'String');
      }
      if (data.hasOwnProperty('countryId')) {
        obj['countryId'] = _ApiClient.default.convertToType(data['countryId'], 'String');
      }
      if (data.hasOwnProperty('customerId')) {
        obj['customerId'] = _ApiClient.default.convertToType(data['customerId'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>AnalyticsSummaryRequest</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AnalyticsSummaryRequest</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of AnalyticsSummaryRequest.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['countryId'] && !(typeof data['countryId'] === 'string' || data['countryId'] instanceof String)) {
      throw new Error("Expected the field `countryId` to be a primitive type in the JSON string but got " + data['countryId']);
    }
    // ensure the json data is a string
    if (data['customerId'] && !(typeof data['customerId'] === 'string' || data['customerId'] instanceof String)) {
      throw new Error("Expected the field `customerId` to be a primitive type in the JSON string but got " + data['customerId']);
    }
    return true;
  }
}
AnalyticsSummaryRequest.RequiredProperties = ["from", "to"];

/**
 * @member {String} from
 */
AnalyticsSummaryRequest.prototype['from'] = undefined;

/**
 * @member {String} to
 */
AnalyticsSummaryRequest.prototype['to'] = undefined;

/**
 * @member {String} countryId
 */
AnalyticsSummaryRequest.prototype['countryId'] = undefined;

/**
 * @member {String} customerId
 */
AnalyticsSummaryRequest.prototype['customerId'] = undefined;
var _default = exports.default = AnalyticsSummaryRequest;